import React from 'react';
import Header from 'components/Header';

const PageHeader = ({ title, subTitle }) => {
  return (
    <Header
      title={title}
      subtitle={subTitle}
    />
  );
};

export default PageHeader;